import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import { UnsavedChangesProvider } from "@/components/UnsavedChangesGuard";
import Login from "@/pages/Login";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import ClientsList from "@/pages/ClientsList";
import ClientForm from "@/pages/ClientForm";
import ClientDetail from "@/pages/ClientDetail";
import Parametres from "@/pages/Parametres";
import Mailbox from "@/pages/Mailbox";
import WhatsApp from "@/pages/WhatsApp";
import Calendrier from "@/pages/Calendrier";
import Atelier from "@/pages/Atelier";
import OrCreate from "@/pages/OrCreate";
import OrDetail from "@/pages/OrDetail";
import AtelierStats from "@/pages/AtelierStats";
import OrParcNouveau from "@/pages/OrParcNouveau";
import OrParcFacturation from "@/pages/OrParcFacturation";
import PublicRdvIa from "@/pages/PublicRdvIa";
import PriseEnChargePage from "@/pages/PriseEnChargePage";
import PriseEnChargeSurPlace from "@/pages/PriseEnChargeSurPlace";
import PublicDevis from "@/pages/PublicDevis";
import RemplacementList from "@/pages/RemplacementList";
import Gardiennage from "@/pages/Gardiennage";
import PretCreate from "@/pages/PretCreate";
import PretDetail from "@/pages/PretDetail";
import PublicPret from "@/pages/PublicPret";
import PublicSuivi from "@/pages/PublicSuivi";
import FlottePlanning from "@/pages/FlottePlanning";
import FacturationCreate from "@/pages/FactureCreate";
import DevisCreate from "@/pages/DevisCreate";
import FactureDetail from "@/pages/FactureDetail";
import FactureAEmettre from "@/pages/FactureAEmettre";
import Facturation from "@/pages/Facturation";
import FacturesFournisseurs from "@/pages/FacturesFournisseurs";
import FactureFournisseurDetail from "@/pages/FactureFournisseurDetail";
import DepensesRapides from "@/pages/DepensesRapides";
import DepenseDetail from "@/pages/DepenseDetail";
import AchatsStatistiques from "@/pages/AchatsStatistiques";
import Comptabilite from "@/pages/Comptabilite";
import Caisse from "@/pages/Caisse";
import Integrations from "@/pages/Integrations";
import DemandesRdv from "@/pages/DemandesRdv";
import Pointage from "@/pages/Pointage";
import PointageAdmin from "@/pages/PointageAdmin";
import Salaires from "@/pages/Salaires";
import PhotoLibrary from "@/pages/PhotoLibrary";

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <UnsavedChangesProvider>
          <Toaster position="top-right" richColors />
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/devis/:token" element={<PublicDevis />} />
          <Route path="/pret/:token" element={<PublicPret />} />
          <Route path="/suivi/:token" element={<PublicSuivi />} />
          <Route path="/widget/rdv" element={<PublicRdvIa />} />
          <Route path="/widget/rdv-ia" element={<PublicRdvIa />} />
          <Route path="/prise-en-charge/:token" element={<PriseEnChargePage />} />
          <Route
            path="/"
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="clients" element={<ClientsList />} />
            <Route path="clients/nouveau" element={<ClientForm />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="clients/:id/modifier" element={<ClientForm />} />
            <Route path="parametres" element={<Parametres />} />
            <Route path="mail" element={<Mailbox />} />
            <Route path="whatsapp" element={<WhatsApp />} />
            <Route path="calendrier" element={<Calendrier />} />
            <Route path="prise-en-charge-sur-place/:token" element={<PriseEnChargeSurPlace />} />
            <Route path="atelier" element={<Atelier />} />
            <Route path="atelier/stats" element={<AtelierStats />} />
            <Route path="photos" element={<PhotoLibrary />} />
            <Route path="atelier/or/nouveau" element={<OrCreate />} />
            <Route path="atelier/or-parc/nouveau" element={<OrParcNouveau />} />
            <Route path="atelier/or-parc/facturation" element={<OrParcFacturation />} />
            <Route path="atelier/or/:id" element={<OrDetail />} />
            <Route path="gardiennage" element={<Gardiennage />} />
            <Route path="remplacement" element={<RemplacementList />} />
            <Route path="remplacement/nouveau" element={<PretCreate />} />
            <Route path="remplacement/:id" element={<PretDetail />} />
            <Route path="planning-flotte" element={<FlottePlanning />} />
            <Route path="facturation" element={<Facturation />} />
            <Route path="facturation/nouveau" element={<FacturationCreate />} />
            <Route path="facturation/devis/nouveau" element={<DevisCreate />} />
            <Route path="facturation/a-emettre/:orId" element={<FactureAEmettre />} />
            <Route path="facturation/:id" element={<FactureDetail />} />
            <Route path="factures-fournisseurs" element={<FacturesFournisseurs />} />
            <Route path="factures-fournisseurs/:id" element={<FactureFournisseurDetail />} />
            <Route path="depenses-rapides" element={<DepensesRapides />} />
            <Route path="depenses-rapides/:id" element={<DepenseDetail />} />
            <Route path="achats/statistiques" element={<AchatsStatistiques />} />
            <Route path="comptabilite" element={<Comptabilite />} />
            <Route path="caisse" element={<Caisse />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="demandes-rdv" element={<DemandesRdv />} />
            <Route path="pointage" element={<Pointage />} />
            <Route path="pointage/admin" element={<PointageAdmin />} />
            <Route path="salaires" element={<Salaires />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </UnsavedChangesProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
